import { Box, Grid, Typography, useMediaQuery, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import strings from '../../Globalization/index';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';
import connectionService from '../../services/Connection';
import EndoIndicatorResult from './EndoIndicatorResult';

const iconMapper = {
	'fa-minus-green': { Icon: RemoveIcon, Color: 'success' },
	'fa-check': { Icon: CheckIcon, Color: 'success' },
	'fa-times': { Icon: CloseIcon, Color: 'error' },
	'fa-plus-red': { Icon: AddIcon, Color: 'error' }
}

const ResultActionButton = ({ Value, handleFormOpen }) => {
	if (Value) {
		const Component = iconMapper[Value];
		return Component ?
			<Component.Icon
				fontSize="large"
				color={Component.Color}
				sx={{ marginTop: -1.3 }}
				onClick={handleFormOpen}
			/> : <></>

	}

	return (
		<Button
			size="small"
			disableElevation
			onClick={handleFormOpen}
			variant="contained"
			className="print-hide"
			startIcon={<AddIcon />}
			sx={{width:'100px'}}		
		>
			{strings.Add}
		</Button>
	);
};

export const customTopSectionInputComponentMapper = {
	"MonitoringStatus": ProcessMonitoringStatus,
	"LCSCIResultIcon": EndoIndicatorResult,
	"STSResultIcon": EndoIndicatorResult,
	"WasherCIResultIcon": ResultActionButton,
	"CIResultIcon": ResultActionButton,
	"BIResultIcon": ResultActionButton,
}

const TopSection = () => {
	const { data } = useCycleInfo();
	const theme = useTheme();
	const screen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

	const topSection = data.TopSection;
	return (
		<Grid container>
			<Box sx={{ flexGrow: 1 }}>
				<Grid container>
					<Grid size={{ xs: 12, lg: 2 }}>
						<Box sx={{ flexGrow: 1, textAlign: 'center' }}>
							<Grid container spacing={1}>
								<Grid size={12}>
									<Box
										component="img"
										src={`${connectionService.PTXImage}/${data.CycleImageUrl}?v=${new Date()}`}
										alt={data.EquipmentName}
										sx={{ height: theme.spacing(12), width: 'auto' }}
										height={theme.spacing(12)}
										width={'auto'}
									/>
								</Grid>

								<Grid size={12}>
									{!!data?.EquipmentName && (
										<Typography
											className="cycle-serialNumber"
											variant="h5"
											fontWeight={'bold'}
											title={strings.EquipmentName}
											component="span"
										>
											{data.EquipmentName}
										</Typography>
									)}
								</Grid>
								<Grid size={12}>
									{!!data?.ModelName && (
										<Typography
											variant="subtitle1"
											fontWeight={'bold'}
											title={strings.ModalName}
											component="span"
										>
											{data.ModelName}
										</Typography>
									)}
								</Grid>
								<Grid size={12}>
									{!!data?.SerialNumber && (
										<Typography
											className="cycle-serialNumber"
											variant="subtitle2"
											fontWeight={'bold'}
											title={strings.SerialNumber}
											component="span"
										>
											{data.SerialNumber === '-1' ? '' : data.SerialNumber}
										</Typography>
									)}
								</Grid>
							</Grid>
						</Box>
					</Grid>
					<Grid size={{ xs: 12, lg: 10 }}>
						{topSection.map(
							(row, i) =>
								row?.length && (
									<Grid
										size={12}
										sx={{
											fontSize: 12,
											display: 'grid',
											gridTemplateColumns: screen ? '1fr 1em 1fr 1fr 1em 1fr' : '1fr 1em 1fr 1fr 1em 1fr 1fr 1em 1fr',
											gap: '3px 5px',
											'& .LabelBold': {
												fontWeight: 'bold'
											}
										}}
										key={`row-${i}`}
									>
										{row.reduce(
											(acc, { HeaderLabel, Name, DataProperty: dataProperty, Value: value, element }, index) => {
												const CustomInputComponent = customTopSectionInputComponentMapper[dataProperty];
												return acc.concat([
													<Typography
														component={'span'}
														className="LabelBold"
														fontSize={'inherit'}
														key={`label-${index}`}
													>
														{strings[HeaderLabel] || strings[Name]}
													</Typography>,
													<Typography
														variant="body2"
														component={'span'}
														fontSize={'inherit'}
														className="LabelBold"
														key={`colon-${index}`}
													>
														:
													</Typography>,
													CustomInputComponent ? (
														<CustomInputComponent
															CriticalParameterIcon={value}
															align='left'
															ml={0}
															data={data}
															dataProperty={dataProperty} />
													) : (
														<Typography
															component={'span'}
															fontSize={'inherit'}
															key={`value-${index}`}
														>
															{element ? element : value}
														</Typography>
													)
												])
											},
											[]
										)}
									</Grid>
								)
						)}
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};
export default memo(TopSection);